import React from "react";
import PropTypes from "prop-types";

export class Body extends React.Component {

    constructor() {
        super();
        this.state = {
            modulesExpanded: false,
        };
        this.toggleModules = this.toggleModules.bind(this);
    }

    toggleModules() {
        this.setState(state => ({
            modulesExpanded: ! state.modulesExpanded,
        }));
    }

    render() {
        const { client, api, aggregate, requiredApi, meta, modules } = this.props;
        const { modulesExpanded } = this.state;

        const rows = meta.map((m, i) => (
               <tr key={i}>
                   <td nowrap="nowrap"><code>{m.key}</code></td>
                   <td nowrap="nowrap"><code>{m.version}</code></td>
               </tr>
           ));

        const versions = meta.map((m, i) => {
            const comma = i + 1 < meta.length ? "," : "";
            return (
                <React.Fragment key={i}>
                    {m.key}:{m.version}{comma}
                </React.Fragment>
            );
        });

        return (
            <div className="row">
                <div className="col-md-12">
                    {requiredApi.indexOf("-SNAPSHOT") > 0 && <div className="alert alert-warning">
                        <strong>SNAPSHOT API REQUIREMENT:</strong> <code>{requiredApi}</code>
                    </div>}
                    <table className="table-alt table-striped table-condensed">
                        <thead>
                        <tr>
                            <th>Module</th>
                            <th>Version</th>
                        </tr>
                        </thead>
                        <tbody>
                        {aggregate && <tr>
                            <td>Aggregate</td>
                            <td><code>{aggregate}</code></td>
                        </tr>}
                        <tr>
                            <td>Client</td>
                            <td><code>{client}</code></td>
                        </tr>
                        <tr>
                            <td>API</td>
                            <td>
                                {modules && <div className="pull-right">
                                    <a
                                        onClick={this.toggleModules}
                                        style={{
                                            cursor: "pointer",
                                            userSelect: "none",
                                        }}
                                    >
                                        {modulesExpanded ? "Hide" : "Show"} Modules
                                    </a>
                                </div>}
                                <code>{api}</code>
                            </td>
                        </tr>
                        {modulesExpanded && modules && modules.map(m =>
                            <tr key={m}>
                                <td/>
                                <td><code>{m}</code></td>
                            </tr>
                        )}
                        {rows}
                        </tbody>
                        <tfoot>
                        <tr>
                            <td>Combined</td>
                            <td><code>{client}&lt;{api}[{versions}]&gt;</code></td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }

}

Body.propTypes = {
    client: PropTypes.string.isRequired,
    api: PropTypes.string.isRequired,
    aggregate: PropTypes.string,
    requiredApi: PropTypes.string.isRequired,
    meta: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            version: PropTypes.string.isRequired,
        })
    ).isRequired,
    modules: PropTypes.arrayOf(
        PropTypes.string
    ),
};



// WEBPACK FOOTER //
// ./app/lib/about/views/Body.js